module.exports = __webpack_public_path__ + "img/PartyQuest_Logo_small.f45fcbfc.png";